import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';

import ReactGA from 'react-ga';
import TableRow from '@material-ui/core/TableRow';
import CircularProgress from '@material-ui/core/CircularProgress';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { toast } from 'react-toastify';

import { Orders } from '../services/smartparking-api';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import ReactPixel from 'react-facebook-pixel';

import { messageByCode } from '../services/utils/BorgunErrors';

const formatISK = (price) =>
    Math.round(price)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');

class Checkout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pan: '',
            expMonth: '',
            expYear: '',
            cvc: '',
            acceptance: false,
            loading: false,
            premiaDiscount: false,
        };
    }

    componentWillMount() {
        this.props.updatePrice();
    }

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleCreditCardInput = (e) => {
        let newInput = e.target.value;

        const rawInput = newInput
            .split('')
            .filter((l) => l != ' ')
            .join('');

        const premiaCredit = '41555204';
        const premiaDebet = '426562039';

        if (rawInput.slice(0, premiaCredit.length) === premiaCredit || rawInput.slice(0, premiaDebet.length) === premiaDebet) {
            this.setState({ premiaDiscount: true });
            this.props.updatePrice(true);
        } else {
            this.setState({ premiaDiscount: false });
            this.props.updatePrice(false);
        }

        newInput = newInput
            .split('')
            .filter((l) => l != ' ')
            .map((s, i) => ((i !== 0 && i % 4) === 0 ? ` ${s}` : s))
            .join('')
            .slice(0, 19);

        this.setState({ pan: newInput });
    };

    submitOrder = (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        const { clientSSN, clientName, clientEmail, clientNumber, clientSenior, vipDiscount, overload } = this.props.order;
        const { carNumber, carSize, carMake, carType, carColor } = this.props.order;
        const { flightNumber, departureTime, departureDate, arrivalTime, arrivalDate } = this.props.order;
        const { price, services, discountGroups, coupon, couponDiscount } = this.props.order;
        // FINAL VALIDATION
        const { acceptance, pan, expMonth, expYear, cvc } = this.state;
        // combine dates

        if (price) {
            if (!pan) {
                this.setState({ loading: false });
                return toast.error('Það vantar kortanúmer');
            }
            if (!expMonth) {
                this.setState({ loading: false });
                return toast.error('Það vantar mánuð í gildistíma');
            }
            if (!expYear) {
                this.setState({ loading: false });
                return toast.error('Það vantar ár í gildistíma');
            }
            if (!cvc) {
                this.setState({ loading: false });
                return toast.error('Það vantar öryggisnúmer ( CVC )');
            }
        }

        if (!acceptance) {
            this.setState({ loading: false });
            return toast.error('Þú verður að samþykkja skilmálana til að halda áfram');
        }

        Orders.create({
            client: {
                name: clientName,
                ssn: clientSSN,
                email: clientEmail,
                phone: clientNumber,
                senior: clientSenior,
                vip: vipDiscount,
            },
            vehicle: {
                reg: carNumber,
                make: carMake,
                type: carType,
                color: carColor,
                size: carSize,
            },
            stay: {
                departure: `${departureDate.format('YYYY-MM-DD')} ${departureTime.format('HH:mm:ss')}`,
                arrival: `${arrivalDate.format('YYYY-MM-DD')} ${arrivalTime.format('HH:mm:ss')}`,
                flightNumber: flightNumber,
            },
            cardInfo: price
                ? {
                      pan: this.state.pan.replace(/ /g, ''),
                      expMonth: this.state.expMonth,
                      expYear: this.state.expYear,
                      cvc: this.state.cvc,
                  }
                : {},
            services: services.filter((s) => s.checked).map((s) => s._id.toString()) || [],
            discounts: discountGroups.filter((s) => s.checked).map((s) => s._id.toString()) || [],
            coupon,
            couponDiscount,
            totalPrice: price,
            overload,
        })
            .then((res) => {
                if (price) {
                    ReactGA.event({
                        category: 'Order',
                        action: 'submitOrder',
                        label: '',
                        value: price,
                    });

                    window.dataLayer.push({ event: 'booking', bookingAmount: price });
                    ReactPixel.track('Purchase', {
                        value: price,
                        currency: 'ISK',
                    });
                }

                window.location = `/receipt/${res.data.receiptId}`;
            })
            .catch((err) => {
                this.setState({ loading: false });
                if (err.response.data.code) {
                    toast.error(messageByCode(err.response.data.code));
                } else {
                    toast.error(err.response.data.message, { duration: 5000 });
                }
            });
    };

    render() {
        const {
            rates,
            tripDuration,
            services,
            discountGroups,
            price,
            fullPrice,
            coupon,
            couponDiscount,
            clientSenior,
            vipDiscount,
            overload,
        } = this.props.order;

        const { premiaDiscount } = this.state;

        const Discount = Math.max(vipDiscount || 0, couponDiscount || 0, clientSenior ? 10 : 0, premiaDiscount ? 25 : 0) || 0;

        return (
            <div>
                <Dialog
                    open={this.props.open}
                    onClose={this.props.onClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    className="checkout"
                >
                    <DialogTitle id="alert-dialog-title" className="checkoutHeader">
                        {'Staðfesta pöntun á Lagningu'}
                    </DialogTitle>
                    {this.state.loading ? (
                        <div className="loader">
                            <CircularProgress />
                        </div>
                    ) : (
                        <div>
                            <Table className="checkoutTable">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Þjónusta</TableCell>
                                        <TableCell numeric>Verð.</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {/* Grunnur */}
                                    <TableRow key={0}>
                                        <TableCell component="th" scope="row">
                                            Grunngjald
                                        </TableCell>
                                        <TableCell numeric>{formatISK(rates.base.price)}</TableCell>
                                    </TableRow>
                                    <TableRow key={1}>
                                        <TableCell component="th" scope="row">
                                            Geymslugjald ( {tripDuration} dagar )
                                        </TableCell>
                                        <TableCell numeric>{formatISK(rates.daily.price * tripDuration)}</TableCell>
                                    </TableRow>
                                    {/* Aukaþjónusta */}
                                    {services
                                        .filter((s) => s.checked === true)
                                        .sort((a, b) => b.price - a.price)
                                        .map((s, i) => (
                                            <TableRow key={`s${i}`}>
                                                <TableCell component="th" scope="row">
                                                    {s.label} {s.daily ? `( ${tripDuration} dagar )` : ''}
                                                </TableCell>
                                                <TableCell numeric>
                                                    {formatISK(s.daily ? s.price * tripDuration : s.price)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    {/* Afslættir */}
                                    {discountGroups
                                        .filter((d, i) => d.checked === true)
                                        .map((d, i) => (
                                            <TableRow key={`d${i}`} className="discounts">
                                                <TableCell component="th" scope="row">
                                                    {d.label}
                                                </TableCell>
                                                <TableCell numeric>
                                                    -{' '}
                                                    {formatISK(
                                                        Math.min(d.max, tripDuration) * rates.daily.price * (d.discount / 100)
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    {!!Discount && (
                                        <TableRow key={`c`} className="discounts">
                                            <TableCell component="th" scope="row">
                                                Afsláttur: ({Discount}%)
                                            </TableCell>
                                            <TableCell numeric>- {formatISK(Math.floor(fullPrice * (Discount / 100)))}</TableCell>
                                        </TableRow>
                                    )}
                                    {!!overload && (
                                        <TableRow key={`c`} className="overload">
                                            <TableCell component="th" scope="row">
                                                Álagsgjald: (20%)
                                            </TableCell>
                                            <TableCell numeric>{formatISK(Math.floor(fullPrice * 0.2))}</TableCell>
                                        </TableRow>
                                    )}
                                    <TableRow key={`f`} className="total">
                                        <TableCell component="th" scope="row">
                                            Heildarupphæð
                                        </TableCell>
                                        <TableCell numeric>{formatISK(price)}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                            <DialogContent>
                                {!!price && (
                                    <div>
                                        <TextField
                                            autoFocus
                                            label="Kortanúmer"
                                            placeholder="**** **** **** ****"
                                            margin="normal"
                                            maxLength="16"
                                            value={this.state.pan}
                                            onChange={this.handleCreditCardInput}
                                            className="checkoutInput creditCardInput"
                                            tabIndex={0}
                                            name="cardnumber"
                                            id="frmCCNum"
                                            helperText={premiaDiscount && Discount === 25 && `⭐ Þú hlýtur 25% Premía afslátt ⭐`}
                                        />
                                        <div className="smallInfo">
                                            <TextField
                                                label="Mánuður"
                                                placeholder="MM"
                                                margin="normal"
                                                maxLength="2"
                                                value={this.state.expMonth}
                                                onChange={(e) => this.setState({ expMonth: e.target.value })}
                                                className="checkoutInput"
                                                tabIndex={1}
                                            />
                                            <TextField
                                                label="Ár"
                                                placeholder="YYYY"
                                                margin="normal"
                                                maxLength="4"
                                                value={this.state.expYear}
                                                onChange={(e) => this.setState({ expYear: e.target.value })}
                                                onFocus={(e) => !e.target.value && this.setState({ expYear: '20' })}
                                                className="checkoutInput"
                                                tabIndex={2}
                                            />
                                            <TextField
                                                label="Öryggisnúmer"
                                                placeholder="***"
                                                margin="normal"
                                                maxLength="4"
                                                value={this.state.cvc}
                                                onChange={(e) => this.setState({ cvc: e.target.value })}
                                                className="checkoutInput"
                                                tabIndex={3}
                                                name="cvc"
                                                id="frmCCCVC"
                                            />
                                        </div>
                                    </div>
                                )}
                                <DialogContentText id="alert-dialog-description" className="criticalInfo">
                                    Með því að smella á "Klára Kaup" staðfesti ég að allar upplýsingar slegnar inn séu réttar og
                                    að ég hafi lesið{' '}
                                    <Link target="_blank" to={'/skilmalar'}>
                                        Skilmála Lagningar
                                    </Link>
                                    <br />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.acceptance}
                                                onChange={(e) => this.setState({ acceptance: e.target.checked })}
                                                value="checkedB"
                                                color="primary"
                                            />
                                        }
                                        label="Ég hef lesið og samþykki skilmála Lagningar"
                                    />
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    onClick={this.submitOrder}
                                    color="primary"
                                    variant="contained"
                                    autoFocus
                                    className="primaryButton"
                                    active={this.state.acceptance}
                                >
                                    Klára Pöntun
                                </Button>
                                {/* <Button onClick={this.props.onClose} color="primary">Hætta Við</Button> */}
                            </DialogActions>
                        </div>
                    )}
                </Dialog>
            </div>
        );
    }
}

export default Checkout;



// WEBPACK FOOTER //
// ./src/views/Checkout.js